import React from 'react';
import { IconBooking, IconPhn } from '../../utils/icons';

interface ContactProps {
  contactItems: {
    booking: boolean
    phn: boolean
  }
  bookingUrl: string
  phnNumber: string
  matomoBookingId?: string
  matomoPhoneId?: string
}

const Contact = ({ contactItems, bookingUrl, phnNumber, matomoBookingId, matomoPhoneId }: ContactProps) => {
	return (
		<aside className="contact">
			{ contactItems.booking && (
				<a id={ matomoBookingId } href={ bookingUrl } className="contact-booking">
					<IconBooking />
					<span>Bestil et opkald</span>
				</a>
			) }
			{ contactItems.phn && (
				<a id={ matomoPhoneId } href={ `tel:${phnNumber}` } className="contact-phn">
					<IconPhn />
					<span>Ring { phnNumber }</span>
				</a>
			) }
		</aside>
	);
};

export default Contact;